exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".buttonText[data-v-0a1caed4]{position:absolute;right:-90px;color:#000;font-size:16px;font-weight:bold}span.cardTitle[data-v-0a1caed4]{font-weight:bold}span.cardText[data-v-0a1caed4]{text-align:left}span.productsTitle[data-v-0a1caed4]{display:block;text-align:center;width:100%;font-size:16px;font-weight:bold}.v-overlay.overlayLoader.theme--dark[data-v-0a1caed4]{z-index:20 !important}", ""]);

// exports
